<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">

    </div>

    <div class="nav material2">
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/customers" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">access_alarm</mat-icon>
                <span>{{'Customers'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/users-online" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">access_alarm</mat-icon>
                <span>{{'Users online'|translate}}</span>
            </a>
        </div>

<!--        <div class="nav-item">-->
<!--            <a class="nav-link" matRipple routerLink="/cards" [routerLinkActive]="[]">-->
<!--                <mat-icon class="nav-link-icon">credit_card</mat-icon>-->
<!--                <span>{{'Cards'|translate}}</span>-->
<!--            </a>-->
<!--        </div>-->

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                <li class="mat-tree-node">
                    <!-- use a disabled button to provide padding for tree leaf -->
                    <button mat-icon-button disabled (click)="filterListByCategory(node.id)"></button>
                    <a matTreeNodeToggle class="nav-link" [routerLinkActive]="['active', 'accent']" (click)="filterListByCategory(node.id)">{{node.name}}</a>
                </li>
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                <li>
                    <div class="mat-tree-node">
                        <button mat-icon-button matTreeNodeToggle
                                [attr.aria-label]="'toggle ' + node.name"
                                (click)="filterListByCategory(node.id)">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                        <a matTreeNodeToggle class="nav-link" [routerLinkActive]="['active', 'accent']" (click)="filterListByCategory(node.id)">{{node.name}}</a>
                    </div>
                    <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                        <ng-container matTreeNodeOutlet></ng-container>
                    </ul>
                </li>
            </mat-nested-tree-node>
        </mat-tree>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
